import {type App} from "vue"
import route from "@/plugins/route"
import {downloadFile, fileUrl, ImageSize} from "@/plugins/file"
import {requestPermissions} from "@/plugins/push"
import errorHandler from "@/plugins/errorHandler"
import BackButton from "@/plugins/backButton/index"
import BreadCrumbs from "@/plugins/breadcrumbs/index"
import axios from "@/plugins/axios"
import auth from "@/plugins/auth"
import gtm from "@/plugins/gtm"
import iap from "@/plugins/iap"
import Confirm from "@/plugins/confirm"
import { ROUTES } from "@/router/paths"
import { createHead, VueHeadMixin } from '@unhead/vue'
import VueDragscroll from "vue-dragscroll"

export function usePlugins(app: App) {
  // Global Mixins
  app.mixin(VueHeadMixin)

  // Plugins
  app.use(axios)
  app.use(auth)
  app.use(BackButton)
  app.use(BreadCrumbs)
  app.use(Confirm)
  app.use(createHead())
  app.use(iap)
  app.use(VueDragscroll)

  if (import.meta.env.VITE_GTM_ID) {
    app.use(gtm)
  }

  app.config.globalProperties.$error = errorHandler
  app.config.globalProperties.$routeTo = route
  app.config.globalProperties.$file = {
    url: fileUrl,
    download: downloadFile,
    imageSize: ImageSize,
  }
  app.config.globalProperties.$push = {
    requestPermissions
  }
  app.config.globalProperties.ROUTES = ROUTES
}
